<template>
  <v-main class="pa-4">
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 rounded-xl">
            <v-card-title class="subtitle-1 font-weight-bold">Token de acesso</v-card-title>
            <v-card-text>
              <v-alert
                v-if="!editandoToken && tokenCadastrado"
                type="info"
                dense
                border="left"
                colored-border
                class="mb-4"
              >
                Token cadastrado. Você pode editar quando precisar.
              </v-alert>

              <v-row align="center">
                <v-col cols="12" md="8">
                  <v-text-field
                    v-model="tokenInput"
                    :disabled="!editandoToken"
                    label="Token"
                    hint="Obrigatório para importar e salvar painéis"
                    persistent-hint
                    outlined
                    dense
                    :error-messages="tokenErro"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex">
                  <v-btn
                    v-if="editandoToken"
                    color="primary"
                    class="mr-2"
                    :disabled="!tokenInput"
                    @click="salvarToken"
                  >
                    Salvar token
                  </v-btn>
                  <v-btn
                    v-else
                    color="secondary"
                    @click="editarToken"
                  >
                    Editar token
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card class="pa-4 rounded-xl">
            <v-card-title class="subtitle-1 font-weight-bold">Status do token</v-card-title>
            <v-card-text>
              <v-alert
                :type="tokenCadastrado ? 'success' : 'warning'"
                dense
                border="left"
                colored-border
              >
                {{ tokenCadastrado ? 'Token cadastrado.' : 'Nenhum token cadastrado.' }}
              </v-alert>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" md="6">
            <v-card class="pa-4 rounded-xl">
              <v-card-title class="subtitle-1 font-weight-bold">Painéis cadastrados</v-card-title>
              <v-card-text>
              <v-alert
                v-if="painelErroMongo"
                type="error"
                dense
                border="left"
                colored-border
                class="mb-4"
              >
                {{ painelErroMongo }}
              </v-alert>
              <v-progress-linear
                v-if="carregandoMongo"
                indeterminate
                color="primary"
                class="mb-4"
              />
              <v-list v-if="!carregandoMongo && paineisCadastrados.length">
                <v-list-item
                  v-for="painel in paineisCadastrados"
                  :key="normalizarIdPainel(painel)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ painel.nome || `Painel ${painel.id_painel || painel.id}` }}</v-list-item-title>
                    <v-list-item-subtitle>
                      ID: {{ painel.id_painel || painel.id }}
                      · API Key: {{ painel.has_api_key ? 'sim' : 'não' }}
                      · Status: {{ painel.ativo ? 'ativo' : 'inativo' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      small
                      color="error"
                      :loading="removendoPainelId === normalizarIdPainel(painel)"
                      :disabled="removendoPainelId === normalizarIdPainel(painel)"
                      @click="removerPainel(painel)"
                    >
                      Remover
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div v-else-if="!carregandoMongo" class="text-body-2">
                Nenhum painel cadastrado.
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
            <v-card class="pa-4 rounded-xl">
              <v-card-title class="subtitle-1 font-weight-bold">Painéis disponíveis</v-card-title>
              <v-card-text>
              <v-alert
                v-if="painelErroApi"
                type="error"
                dense
                border="left"
                colored-border
                class="mb-4"
              >
                {{ painelErroApi }}
              </v-alert>
              <v-progress-linear
                v-if="carregandoApi"
                indeterminate
                color="primary"
                class="mb-4"
              />
              <v-list v-if="!carregandoApi && paineisDisponiveisFiltrados.length">
                <v-list-item
                  v-for="painel in paineisDisponiveisFiltrados"
                  :key="normalizarIdPainel(painel)"
                >
                  <v-list-item-action>
                    <v-checkbox
                      :input-value="painelSelecionado(painel)"
                      :disabled="adicionandoPainel"
                      @change="toggleSelecionado(painel)"
                    />
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ painel.nome || `Painel ${painel.id_painel || painel.id}` }}</v-list-item-title>
                    <v-list-item-subtitle>
                      ID: {{ painel.id_painel || painel.id }}
                      · API Key: {{ painel.has_api_key ? 'sim' : 'não' }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <div v-else-if="!carregandoApi" class="text-body-2">
                Nenhum painel disponível para cadastrar.
              </div>
              <div class="d-flex mt-4">
                <v-btn
                  color="primary"
                  :disabled="!paineisSelecionados.length || adicionandoPainel"
                  :loading="adicionandoPainel"
                  @click="adicionarSelecionados"
                >
                  Cadastrar selecionados
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'PaineisExternos',
  data () {
    return {
      tokenInput: '',
      tokenSalvo: '',
      tokenErro: '',
      editandoToken: true,
      temTokenServidor: false,
      user: null,
      paineisCadastrados: [],
      paineisDisponiveis: [],
      paineisSelecionados: [],
      carregandoMongo: false,
      carregandoApi: false,
      adicionandoPainel: false,
      removendoPainelId: '',
      painelErroMongo: '',
      painelErroApi: ''
    }
  },
  computed: {
    tokenValido () {
      return this.tokenSalvo.trim().length > 0
    },
    tokenCadastrado () {
      return this.tokenValido || this.temTokenServidor
    },
    paineisDisponiveisFiltrados () {
      if (!this.paineisDisponiveis.length) return []
      const cadastrados = new Set(this.paineisCadastrados.map((painel) => this.normalizarIdPainel(painel)))
      return this.paineisDisponiveis.filter((painel) => !cadastrados.has(this.normalizarIdPainel(painel)))
    }
  },
  mounted () {
    this.carregarTokenLocal()
    this.user = this.$store.getters.usuario
    this.carregarConfiguracao()
  },
  methods: {
    carregarTokenLocal () {
      const token = window.localStorage.getItem('paineisExternosToken') || ''
      this.tokenSalvo = token
      this.tokenInput = token
      this.editandoToken = !token
    },
    async carregarConfiguracao () {
      try {
        const rsp = await administradorUnidadeService.administradorUnidade.retornarPaineisUnidade()
        if (rsp && rsp.status === 200 && rsp.data && typeof rsp.data === 'object') {
          const tokenRetornado = rsp.data.token || rsp.data.master_key || rsp.data.masterKey || rsp.data.key
          const tokenFinal = tokenRetornado ? String(tokenRetornado).trim() : ''
          if (tokenFinal) {
            window.localStorage.setItem('paineisExternosToken', tokenFinal)
            this.tokenSalvo = tokenFinal
            this.tokenInput = tokenFinal
            this.temTokenServidor = true
            this.editandoToken = false
            await this.carregarListasPaineis()
            return
          }
        }
        if (rsp && rsp.status === 204) {
          this.temTokenServidor = false
          this.consultarTokenServidor()
          await this.carregarListasPaineis()
          return
        }
        this.consultarTokenServidor()
        await this.carregarListasPaineis()
      } catch (error) {
        console.log('Erro ao carregar configuração de painéis:', error)
        this.consultarTokenServidor()
        await this.carregarListasPaineis()
      }
    },
    normalizarIdPainel (painel) {
      const id = painel && (painel.id_painel || painel.id)
      return id != null ? String(id) : ''
    },
    painelSelecionado (painel) {
      const id = this.normalizarIdPainel(painel)
      return this.paineisSelecionados.some((item) => this.normalizarIdPainel(item) === id)
    },
    toggleSelecionado (painel) {
      const id = this.normalizarIdPainel(painel)
      const index = this.paineisSelecionados.findIndex((item) => this.normalizarIdPainel(item) === id)
      if (index >= 0) {
        this.paineisSelecionados.splice(index, 1)
        return
      }
      this.paineisSelecionados.push(painel)
    },
    async carregarListasPaineis () {
      await Promise.all([this.carregarPaineisMongo(), this.carregarPaineisApi()])
    },
    async carregarPaineisMongo () {
      this.carregandoMongo = true
      this.painelErroMongo = ''
      try {
        const rsp = await administradorUnidadeService.administradorUnidade.listarPaineisMongo()
        const paineis = rsp && rsp.data && Array.isArray(rsp.data.paineis) ? rsp.data.paineis : []
        this.paineisCadastrados = paineis
        const cadastrados = new Set(this.paineisCadastrados.map((painel) => this.normalizarIdPainel(painel)))
        this.paineisSelecionados = this.paineisSelecionados.filter((painel) => !cadastrados.has(this.normalizarIdPainel(painel)))
      } catch (error) {
        this.painelErroMongo = 'Não foi possível carregar os painéis cadastrados.'
        console.log('Erro ao carregar painéis do Mongo:', error)
      } finally {
        this.carregandoMongo = false
      }
    },
    async carregarPaineisApi () {
      this.carregandoApi = true
      this.painelErroApi = ''
      try {
        const rsp = await administradorUnidadeService.administradorUnidade.listarPaineisApi()
        const paineis = rsp && rsp.data && Array.isArray(rsp.data) ? rsp.data : (rsp.data && rsp.data.paineis) || []
        this.paineisDisponiveis = Array.isArray(paineis) ? paineis : []
      } catch (error) {
        this.painelErroApi = 'Não foi possível carregar os painéis disponíveis.'
        console.log('Erro ao carregar painéis da API:', error)
      } finally {
        this.carregandoApi = false
      }
    },
    async adicionarSelecionados () {
      if (!this.paineisSelecionados.length) return
      this.adicionandoPainel = true
      try {
        for (const painel of this.paineisSelecionados) {
          const payload = {
            idUnidade: this.user.idUnidade,
            acao: 'adicionar',
            painel: {
              id_painel: this.normalizarIdPainel(painel),
              nome: painel.nome,
              has_api_key: !!painel.has_api_key,
              ativo: painel.ativo != null ? !!painel.ativo : true
            }
          }
          await administradorUnidadeService.administradorUnidade.atualizarListaPaineis(payload)
        }
        this.paineisSelecionados = []
        await this.carregarListasPaineis()
      } catch (error) {
        this.painelErroApi = 'Não foi possível cadastrar os painéis selecionados.'
        console.log('Erro ao cadastrar painéis:', error)
      } finally {
        this.adicionandoPainel = false
      }
    },
    async removerPainel (painel) {
      const idPainel = this.normalizarIdPainel(painel)
      if (!idPainel) return
      this.removendoPainelId = idPainel
      try {
        const payload = {
          idUnidade: this.user.idUnidade,
          acao: 'remover',
          painel: { id_painel: idPainel }
        }
        await administradorUnidadeService.administradorUnidade.atualizarListaPaineis(payload)
        await this.carregarListasPaineis()
      } catch (error) {
        this.painelErroMongo = 'Não foi possível remover o painel.'
        console.log('Erro ao remover painel:', error)
      } finally {
        this.removendoPainelId = ''
      }
    },
    async consultarTokenServidor () {
      try {
        const rsp = await administradorUnidadeService.administradorUnidade.temTokenCadastrado()
        if (typeof rsp.data === 'boolean') {
          this.temTokenServidor = rsp.data
          return
        }
        if (rsp.data && typeof rsp.data === 'object') {
          if (typeof rsp.data.temToken === 'boolean') {
            this.temTokenServidor = rsp.data.temToken
          } else if (typeof rsp.data.tokenCadastrado === 'boolean') {
            this.temTokenServidor = rsp.data.tokenCadastrado
          } else if (typeof rsp.data.token === 'string' && rsp.data.token.trim().length > 0) {
            this.temTokenServidor = true
          }
        }
      } catch (error) {
        console.log('Erro ao consultar token cadastrado:', error)
      }
    },
    async salvarToken () {
      this.tokenErro = ''
      const valor = this.tokenInput.trim()
      if (!valor) {
        this.tokenErro = 'Informe um token válido.'
        return
      }
      try {
        const rsp = await administradorUnidadeService.administradorUnidade.cadastrarTokenUnidade({
          idUnidade: this.user.idUnidade,
          token: valor
        })
        const tokenRetornado = rsp && rsp.data
          ? (rsp.data.token || rsp.data.master_key || rsp.data.masterKey || rsp.data.key)
          : null
        const tokenFinal = String(tokenRetornado || valor).trim()
        window.localStorage.setItem('paineisExternosToken', tokenFinal)
        this.tokenSalvo = tokenFinal
        this.tokenInput = tokenFinal
        this.temTokenServidor = true
        this.editandoToken = false
        await this.carregarListasPaineis()
      } catch (error) {
        this.tokenErro = 'Não foi possível salvar o token.'
        console.log('Erro ao salvar token:', error)
      }
    },
    editarToken () {
      this.editandoToken = true
      this.tokenInput = this.tokenSalvo
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 18px;
}
</style>
